import { useState } from "react";
import { ArrowDown, ArrowRight } from "lucide-react";
import { UI } from "./profileData";

const FlowView = ({ flow, lang }) => (
  <div className="flex flex-col items-stretch gap-2 md:flex-row md:items-center" data-testid="arch-flow">
    {flow.map((n, i) => (
      <div key={n.label} className="flex flex-col items-center gap-2 md:flex-1 md:flex-row">
        <div className="w-full rounded-lg border border-sky-400/30 bg-[#081B33] px-3 py-2 text-center">
          <p className="font-mono text-xs font-semibold text-sky-300">{n.label}</p>
          <p className="mt-0.5 text-[11px] text-slate-500">{n.sub[lang]}</p>
        </div>
        {i < flow.length - 1 && (
          <>
            <ArrowDown className="h-4 w-4 shrink-0 text-[#FF5500] md:hidden" />
            <ArrowRight className="hidden h-4 w-4 shrink-0 text-[#FF5500] md:block" />
          </>
        )}
      </div>
    ))}
  </div>
);

const LayersView = ({ layers, lang }) => (
  <div className="flex flex-col gap-2" data-testid="arch-layers">
    {layers.map((l, i) => (
      <div key={l.name.en} className="flex flex-col gap-1 rounded-lg bg-[#081B33] px-3 py-2 sm:flex-row sm:items-center sm:gap-3">
        <span className="whitespace-nowrap font-mono text-xs text-[#FF7A33] sm:w-44">L{i + 1} · {l.name[lang]}</span>
        <div className="flex flex-wrap gap-3">
          {l.items.map((it) => (
            <span key={it} className="font-mono text-xs text-slate-300">{it}</span>
          ))}
        </div>
      </div>
    ))}
  </div>
);

export const ArchitectureDiagram = ({ project, lang }) => {
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState("flow");
  const t = UI[lang];
  const tabCls = (k) =>
    `whitespace-nowrap rounded-md px-3 py-1.5 font-mono text-[11px] sm:text-xs transition-colors duration-200 ${tab === k ? "bg-[#FF5500] text-white" : "text-slate-400 hover:text-white"}`;
  return (
    <div className="mt-5">
      <button
        onClick={() => setOpen((v) => !v)}
        className="font-mono text-xs text-[#FF7A33] hover:underline"
        data-testid={`arch-toggle-${project.id}`}
      >
        {open ? `− ${t.archHide}` : `+ ${t.archShow}`}
      </button>
      {open && (
        <div className="section-fade-in mt-4 rounded-xl border border-white/10 bg-black/20 p-4" data-testid={`arch-panel-${project.id}`}>
          <div className="mb-4 flex gap-2">
            <button className={tabCls("flow")} onClick={() => setTab("flow")} data-testid={`arch-tab-flow-${project.id}`}>{t.flowTab}</button>
            <button className={tabCls("layers")} onClick={() => setTab("layers")} data-testid={`arch-tab-layers-${project.id}`}>{t.layersTab}</button>
          </div>
          {tab === "flow" ? <FlowView flow={project.flow} lang={lang} /> : <LayersView layers={project.layers} lang={lang} />}
        </div>
      )}
    </div>
  );
};

export default ArchitectureDiagram;
